// TODO: unused, remove?
// eslint-disable-next-line no-redeclare,no-unused-vars
function checkFilter(row, filter) {
    var success = true;
    $.each(filter, function(key, value) {
        if (row[key] != value) success = false;
    });
    return success;
}

//# sourceMappingURL=index.bf492139.js.map
